import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

import { TranslateModule } from '@ngx-translate/core';

import { PatientNameAndDob } from '../../../pages/patient-details/patient-details.component';

@Component({
  selector: 'app-patient-info-card',
  templateUrl: './patient-info-card.component.html',
  styleUrls: ['./patient-info-card.component.scss'],
  imports: [CommonModule, MatCardModule, MatButtonModule, MatIconModule, TranslateModule],
  standalone: true,
})
export class PatientInfoCardComponent {
  @Input() patientInfo!: PatientNameAndDob;
  @Output() closeCard = new EventEmitter<void>();

  public onClose(): void {
    this.closeCard.emit();
  }
}
